import React, { Component } from 'react';
import { Icon, Tooltip, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { DialogWrapper } from 'components/DialogWrapper';
import { AppToaster } from 'components/AppToaster';
import { archiveQuestionnaireQuestion } from 'api/questionnaire';
import QuestionnaireAnswers from 'containers/Manage-Questionnaire/questionnaire/QuestionnaireAnswers';
import QuestionnaireEditQuestionDrawer from 'containers/Manage-Questionnaire/questionnaire/QuestionnaireEditQuestionDrawer';
import { Container } from 'components/styled-components';
import colors from 'utils/colors';
import {
  Wrapper,
  Title,
  Controls,
  TitleWrapper,
  QuestionDetails,
  DetailItemWrapper,
  DetailItemTitle,
  DetailItemValue,
  Status,
  StatusLabel,
  StatusValue,
} from 'containers/Manage-Questionnaire/styled-components';
import { findValue, statusByVersionStatus } from 'utils/functions';
import styled from 'styled-components';
import { shouldBold } from 'utils/functions';

class QuestionnaireTableRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      removeOpen: false,
    };
  }

  openDrawer = () =>
    this.setState(
      { isOpen: true },
      this.props.setQuestionnaireIndex(this.props.index)
    );
  closeDrawer = () =>
    this.setState({ isOpen: false }, () =>
      this.props.setQuestionnaireIndex(null)
    );

  openRemoveDialog = () => this.setState({ removeOpen: true });
  handleDismissRemove = () => this.setState({ removeOpen: false });

  handleArchiveQuestion = () => {
    const { question } = this.props;
    archiveQuestionnaireQuestion(question.questionID, question.versionStatus)
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        this.props.fetchQuestionnaireQuestions();
        this.handleDismissRemove();
        this.closeDrawer();
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
      });
  };

  render() {
    const { question, searchQuery } = this.props;
    const status = statusByVersionStatus(question.versionStatus);

    return (
      <Container background={colors.whiteGray} width="95%">
        <Wrapper>
          <TitleWrapper>
            <Title>{shouldBold(question.question, searchQuery)}</Title>
            <Status>
              <StatusLabel>QUESTION ID:</StatusLabel>{' '}
              <StatusValue>{question.questionID}</StatusValue>
            </Status>

            <Controls width="13rem">
              <Status>
                <StatusLabel>STATUS:</StatusLabel>{' '}
                <StatusValue>{question.versionStatus}</StatusValue>
              </Status>
              <ToolTipWrapper>
                <Tooltip content="Edit">
                  <Icon
                    icon={IconNames.EDIT}
                    onClick={this.openDrawer}
                    style={{ cursor: 'pointer' }}
                  />
                </Tooltip>
                <Tooltip content={status.getStatus}>
                  <Icon
                    icon={status.getIcon}
                    onClick={this.openRemoveDialog}
                    style={{ cursor: 'pointer' }}
                  />
                </Tooltip>
              </ToolTipWrapper>
              <DialogWrapper
                isOpen={this.state.removeOpen}
                onClose={this.handleDismissRemove}
                title={status.getTitle}
                body={status.getBody}
                confirm={status.getConfirm}
                action={this.handleArchiveQuestion}
              />
            </Controls>
          </TitleWrapper>
          <QuestionnaireAnswers
            answers={question.answers}
            openParent={this.openDrawer}
            isParentOpen={this.state.isOpen}
            question={question}
            fetchQuestionnaireQuestions={this.props.fetchQuestionnaireQuestions}
            categories={this.props.categories}
          />
          <QuestionDetails style={{ borderRadius: '0 0 3px 3px' }}>
            <DetailItemWrapper>
              <DetailItemTitle>Question Type</DetailItemTitle>
              <DetailItemValue>
                {findValue(
                  this.props.questionTypes,
                  'typeID',
                  question.questionTypeID,
                  'typeName'
                )}
              </DetailItemValue>
            </DetailItemWrapper>
            <DetailItemWrapper>
              <DetailItemTitle>Control Number</DetailItemTitle>
              <DetailItemValue>{question.controlID}</DetailItemValue>
            </DetailItemWrapper>
            <DetailItemWrapper>
              <DetailItemTitle>Display Category</DetailItemTitle>
              <DetailItemValue>
                {findValue(
                  this.props.categories,
                  'categoryID',
                  question.displayCategoryID,
                  'categoryName'
                )}
              </DetailItemValue>
            </DetailItemWrapper>
            <DetailItemWrapper>
              <DetailItemTitle>Weight</DetailItemTitle>
              <DetailItemValue>{question.weight}</DetailItemValue>
            </DetailItemWrapper>
            <DetailItemWrapper>
              <DetailItemTitle>Default</DetailItemTitle>
              <DetailItemValue>
                {question.defaultQuestion ? 'Yes' : 'No'}
              </DetailItemValue>
            </DetailItemWrapper>
          </QuestionDetails>
        </Wrapper>
        <QuestionnaireEditQuestionDrawer
          isOpen={this.state.isOpen}
          question={question}
          closeDrawer={this.closeDrawer}
          openParent={this.openDrawer}
          isParentOpen={this.state.isOpen}
          {...this.props}
        />
      </Container>
    );
  }
}

export default QuestionnaireTableRow;

export const ToolTipWrapper = styled.div`
  display: flex;
  width: 4rem;
  justify-content: space-evenly;
`;
